import DEFAULT from '@/config/premadeConfigs'
import { PartnerConfig } from '@/types'

const { LOGOS, USA } = DEFAULT
const { CONTENT_V2: content } = USA

const partnerName = 'CalViva Health'

const calviva: PartnerConfig = {
  branding: {
    logo: [LOGOS.BABYLON],
  },
  config: {
    ...USA.CONFIG_V2,
    id: 'cal-viva',
    productConfigAppName: 'cal-viva',
    name: partnerName,
    codes: {
      membership: 'CVMC',
    },
    partnerUrlSlug: 'calviva',
  },
  content,
}

const calvivaWithDnaV2Design: PartnerConfig = {
  ...calviva,
  config: {
    ...calviva.config,
    useDnaV2Design: true,
  },
}

export default [calviva, calvivaWithDnaV2Design]
